import type { Plan } from "@headerhawk/core";

export type Capability =
  | "reports.view"
  | "reports.export"
  | "scripts.inventory"
  | "scripts.pages";

const PLAN_CAPABILITIES: Record<Plan, readonly Capability[]> = {
  free: ["reports.view", "reports.export"],
  team: ["reports.view", "reports.export", "scripts.inventory"],
  professional: [
    "reports.view",
    "reports.export",
    "scripts.inventory",
    "scripts.pages",
  ],
  business: [
    "reports.view",
    "reports.export",
    "scripts.inventory",
    "scripts.pages",
  ],
};

export function hasCapability(plan: Plan, capability: Capability): boolean {
  return PLAN_CAPABILITIES[plan].includes(capability);
}
